import React from 'react'
import { Row, Col, Card, CardHeader, CardBody, } from 'reactstrap'
import ItemQuestion from './AssignmentItemView/ItemQuestion'
import ItemAnswer from './AssignmentItemView/ItemAnswer'
import ItemSubmit from './AssignmentItemView/ItemSubmit'
import arrayifyWithKey from '../../helpers/arrayifyWithKey'
import alphaNum from '../../helpers/alphaNum'
import ItemNext from './AssignmentItemView/ItemNext'
import ItemFeedback from './AssignmentItemView/ItemFeedback'
import ItemPassage from './AssignmentItemView/ItemPassage'

// Question, Answer Choices (each of which can be selected), submit answer button, feedback, lock out if already completed
// itemQuestion props: active, choice, answer
  
/*

When completed:
  Display the work and the feedback
  Link to next item

At all times:
  Arrows left and right to navigate to next and previous items
  Nav back to Assignments


  IF NEXTITEMLINKTO === '' THEN WE HAVE TO GO BACK TO THE ASSIGNMENT PAGE AS THE LINK...
*/

export default function AssignmentItemView (props) {
  let itemAnswers = null
  if (props.activeItem) {
    const answersArray = arrayifyWithKey(props.activeItem.answers)
    itemAnswers = answersArray.map( (answer, n) => {
      let active = false
      if (props.selectedAnswer === answer.key) {
        active = true
      }
      return (
        <ItemAnswer
          key={'itemAnswer' + n}
          active={active}
          choice={alphaNum[n.toString()]}
          answer={answer}
          selectAnswer={props.selectAnswer}
          completed={props.completed}
        />
      )
    })
  }

  let button = <ItemSubmit active={props.selectedAnswer ? true : false} handleSubmit={props.handleSubmit}/>
  if (props.completed) {
    button = <ItemNext last={props.nextItemLinkTo.last} nextItemLinkTo={props.nextItemLinkTo.link}/>
  }

  let itemFeedback = null
  if (props.activeItem && props.selectedAnswer) {
    itemFeedback = <ItemFeedback feedback={props.activeItem.answers[props.selectedAnswer].feedback} completed={props.completed} />
  }

  return (
    <Row>
      <Col xs='12' md='7'>
        <ItemPassage passage={props.activeItem ? props.activeItem.passage : ''} />
      </Col>
      <Col xs='12' md='5'>
        <Card>
          <CardHeader>
            {`Item ${props.itemNumber}`}
          </CardHeader>
          <CardBody>
            <ItemQuestion question={props.activeItem ? props.activeItem.question : null} />
            {itemAnswers}
            {button}
            {itemFeedback}
          </CardBody>
        </Card>
      </Col>
    </Row>
  )
}


// WEBPACK FOOTER //
// ./src/components/Assignments/AssignmentItemView.js